import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import Progress from "./Progress";
import AppBody from "./AppBody";

/* global Word */

export default class App extends React.Component {


  constructor(props, context) {
    super(props, context);
  }

  render() {
   
    const {title, isOfficeInitialized } = this.props;

    if (!isOfficeInitialized) {
      return (
        <Progress title={title} logo="assets/logo-filled.png" message="Please sideload your addin to see app body." />
      );
    }

    return (
        <div>
          <AppBody />
        </div>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};
